if(typeof mc_area_model_promo2 === 'undefined') {var e = new Error("Cannot find module \"mc_area_model_promo2\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = mc_area_model_promo2;


//////////////////
// WEBPACK FOOTER
// external "mc_area_model_promo2"
// module id = 243
// module chunks = 0